import { Injectable } from '@angular/core';
import { Countries } from '@ux/entities/country.enum';

import { isNullOrUndefined } from '@app/util/util';
import { isAzulAir, isClicAir, isGolAir, isSatenaAir } from '@flight-results/mappers/flights.mapper';
import { TypeOfLuggage } from '@shared/luggage/constants/type-luggage';
import { environment as ENV } from '@environment';


@Injectable()
export class LuggageService {

  constructor() { }

  public includesLuggageWarehouse(baggage: number): boolean {
    return !this.isNull(baggage) && !this.isZero(baggage)
  }

  public warehouseTitle(baggage: number): string {
    if (this.isNull(baggage)) {
      return 'LUGGAGE_MODULE.BAGGAGE.NO_INFORMATION.TITLE';
    }  else if (this.isZero(baggage)) {
      return 'LUGGAGE_MODULE.BAGGAGE.NO_BAGGAGE.TITLE';
    } else {
      return 'LUGGAGE_MODULE.BAGGAGE.IN_WAREHOUSE.TITLE';
    } 
  }

  public warehouseSubtitle(
    baggage: number,
    typeOfLuggage: TypeOfLuggage,
  ): string {
    if (this.isNull(baggage)) {
      return 'LUGGAGE_MODULE.BAGGAGE.NO_INFORMATION.TEXT';
    }  else if (this.isZero(baggage)) {
      return 'LUGGAGE_MODULE.BAGGAGE.NO_BAGGAGE.TEXT';
    } else if (this.isByWeightType(typeOfLuggage)) {
      return 'LUGGAGE_MODULE.BAGGAGE.IN_WAREHOUSE.WEIGHT_TEXT';
    } else if (this.isSingularBaggage(baggage)) {
      return 'LUGGAGE_MODULE.BAGGAGE.IN_WAREHOUSE.SINGULAR_TEXT';
    } else {
      return 'LUGGAGE_MODULE.BAGGAGE.IN_WAREHOUSE.PLURAL_TEXT';
    } 
  }

  public disableBackpackLuggage(airlineCode: string): boolean {
    return (isAzulAir(airlineCode) && ENV.countryInfo.iso_code !== Countries.Brazil) || 
            isGolAir(airlineCode) || isClicAir(airlineCode) || isSatenaAir(airlineCode);
  }

  private isByWeightType(typeOfLuggage: TypeOfLuggage): boolean {
    return typeOfLuggage === TypeOfLuggage.ByWeight;
  }

  private isSingularBaggage(baggage: number): boolean {
    return !this.isNull(baggage) && !this.isZero(baggage) && baggage === 1;
  }

  private isNull(baggage: number): boolean {
    return isNullOrUndefined(baggage) || isNaN(baggage);
  }

  private isZero(baggage: number): boolean {
    return baggage === 0;
  }
}
